var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.496,
    height: 14.495,
    viewBox: "0 0 14.496 14.495",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4426",
    "data-name": "Group 4426",
    transform: "translate(-334.002 -31.754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8803",
    "data-name": "Path 8803",
    d: "M-17065.8-21752.639h17.5",
    transform: "translate(-2979.029 27481.598) rotate(45)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8884",
    "data-name": "Path 8884",
    d: "M-17065.8-21752.639h17.5",
    transform: "translate(27783.846 3359.281) rotate(-45)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.34a60c0f11010336b418ed087ec8a3a8.svg";
export { ForwardRef as ReactComponent };